import api from '../api';

export default class ConfigurationService {
  static retrieveConfiguration() {
    return api.get('parameters')
      .then((response) => new Promise((resolve) => { resolve(response.data); }))
      .catch((error) => new Promise((resolve, reject) => { reject(error); }));
  }
}
